import React from 'react'
import Breakout from '../Breakout'
import ExampleChild from './ExampleChild'

class Example extends React.Component {
  constructor(props) {
    super(props)
    this.state = { useBreakout: false }
    this.wrapperEl = null
  }

  onRefWrapper = el => {
    this.wrapperEl = el
  }

  toggleBreakout = () => {
    this.setState({ useBreakout: !this.state.useBreakout })
  }

  closeBreakout = () => {
    this.setState({ useBreakout: false })
  }

  render() {
    const theCode = `
      useBreakout
          ? <Breakout><Component /></Breakout>
          : <Component />;
    `

    return (
      <React.Fragment>
      <div style={{margin: '100px auto', width: '80%', height: '180px', padding: '20px', border: '1px solid #ddd', overflow: 'scroll', overflowX: 'hidden'}}>

        <div ref={this.onRefWrapper} style={{position: 'relative', width: '50%', height: '300px'}}>

          { this.state.useBreakout
            ? <Breakout trackElement={this.wrapperEl} onClickOutside={this.closeBreakout}>
              <ExampleChild onClickButton={this.toggleBreakout} key='child' />
            </Breakout>
            : <ExampleChild onClickButton={this.toggleBreakout} key='child' />
          }

        </div>

      </div>
      <div style={{margin: '-50px auto', width: '80%'}}>
        Click the Toggle breakout button, notice how the element sits on top of everything, but can still be scrolled as if it was inside the container.
        <br /><br />
        The gist:
        <br />
        <pre style={{fontSize:'13px'}}>{ theCode }</pre>
        <br />Note:<br />
        One major caveat with Breakout is that the enclosed component is always re-mounted, which is a feature of React Portal.
        <br />
        So all local state is wiped. Ideally it should only be used with controlled components.
        <br /><br />
        @see readme.md for infos on props
        <br /><br />
      </div>
      </React.Fragment>
    )
  }
}

export default Example
